<div *ngIf="mode === 'view'" class="field field_size_{{ size ? size : 'l' }}">
  <div class="field__name">{{ name }} &nbsp;</div>
  <div class="field__value">
    <app-link [url]="'tel:' + (phoneNumber ?? text)" [displayText]="text"></app-link>
    <app-whats-app-link *ngIf="phoneNumber" [value]="phoneNumber"></app-whats-app-link>
    <app-telegram-link *ngIf="phoneNumber" [value]="phoneNumber"></app-telegram-link>
  </div>
</div>
